import React, { useState, useEffect } from 'react';
import { InputMask } from '@react-input/mask';
import Select from "react-select";
import api from '../../../../config/axios';
import Swal from 'sweetalert2';

import { autoCompleteBancos } from "../../../../components/utils/autocompletes";
import { FaRegSave, FaTimes } from 'react-icons/fa';

const FornecedorModal = ({ fornecedor, onClose, onFornecedorAtualizado }) => {
	const [tituloModal, setTituloModal] = useState("");
	const { inputPesquisaBanco, bancosOptions, handleAutoCompleteBancos, handleFocusBancos } = autoCompleteBancos();
	const [formData, setFormData] = useState({
		nome: '',
		data_nascimento: '',
		sexo: '',
		cpf: '',
		cnpj: '',
		e_estrangeiro: false,
		documento_estrangeiro: '',
		ddi: '+55',
		telefone: '',
		celular: '',
		email: '',
		observacao: '',
		cep: '',
		rua: '',
		endereco: '',
		numero: '',
		estado: '',
		cidade: '',
		bairro: '',
		complemento: '',

		nome_fantasia: '',
		razao_social: '',
		responsavel: '',
		banco: '',
		tipo_conta: 'corrente',
		agencia: '',
		conta: '',
		conta_digito: '',
		nome_titular: '',
		documento_titular: '',
	});

	const customStyles = {
		menu: (provided) => ({
			...provided,
			whiteSpace: "pre-line",
		}),
		option: (provided) => ({
			...provided,
			whiteSpace: "pre-wrap",
			wordBreak: "break-word",
		}),
	};

	const handleSelectChange = async (name, value) => {
		setFormData((prevState) => ({
			...prevState,
			[name]: value || "",
		}));
	};

	useEffect(() => {
		if (fornecedor != null) {
			setFormData({
				...fornecedor,
				data_nascimento: fornecedor.data_nascimento ? fornecedor.data_nascimento.split('-').reverse().join('/') : '',

				nome_fantasia: fornecedor.dadosFornecedor?.nome_fantasia || '',
				razao_social: fornecedor.dadosFornecedor?.razao_social || '',
				responsavel: fornecedor.dadosFornecedor?.responsavel || '',
				banco: fornecedor.dadosFornecedor?.dadosBanco ? { value: fornecedor.dadosFornecedor.dadosBanco.id, label: fornecedor.dadosFornecedor.dadosBanco.nome } : '',
				tipo_conta: fornecedor.dadosFornecedor?.tipo_conta || 'corrente',
				agencia: fornecedor.dadosFornecedor?.agencia || '',
				conta: fornecedor.dadosFornecedor?.conta ? fornecedor.dadosFornecedor.conta.slice(0, -1) : '',
				conta_digito: fornecedor.dadosFornecedor?.conta ? fornecedor.dadosFornecedor.conta.slice(-1) : '',
				nome_titular: fornecedor.dadosFornecedor?.nome_titular || '',
				documento_titular: fornecedor.dadosFornecedor?.documento_titular || '',
			});

			setTituloModal('Editar Fornecedor');
		}
		else {
			setTituloModal('Novo Fornecedor');
		}
	}, [fornecedor]);


	const estados = [
		'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG',
		'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO',
	];

	const handleChange = (e) => {
		const { name, value, type, checked } = e.target;
		setFormData({
			...formData,
			[name]: type === 'checkbox' ? checked : value
		});
	};

	const buscarEndereco = async () => {
		const cepLimpo = formData.cep.replace("-", "");
		if (cepLimpo.length === 8) {
			try {
				const response = await api.get(`/cep/${cepLimpo}`);

				setFormData({
					...formData,
					estado: response.data.UF,
					cidade: response.data.CIDADE,
					bairro: response.data.BAIRRO,
					rua: response.data.RUA,
				});
			} catch (error) {
				throw error;
			}
		}
	};

	const formatarDataRequisicao = (data) => {
		if (!data) return null;
		const [dia, mes, ano] = data.split('/');
		return `${ano}-${mes}-${dia}`;
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		const camposObrigatorios = [
			{ campo: 'nome', label: 'Nome' },
			{ campo: 'celular', label: 'Celular' },
			{ campo: 'nome_fantasia', label: 'Nome Fantasia' },
			{ campo: 'razao_social', label: 'Razão Social' },
			{ campo: 'cnpj', label: 'CNPJ' },
			{ campo: 'banco', label: 'Banco' }
		];

		const camposInvalidos = camposObrigatorios.filter(({ campo }) => {
			const valor = formData[campo];

			if (typeof valor === 'string') return !valor.trim();

			if (typeof valor === 'object' && valor !== null) return !valor.value;

			return !valor;
		});

		if (camposInvalidos.length > 0) {
			Swal.fire(
				'Erro',
				`Os seguintes campos são obrigatórios: ${camposInvalidos.map(c => c.label).join(', ')}`,
				'error'
			);
			return;
		}

		const data = {
			...formData,
			e_fornecedor: true,
			e_cliente: false,
			e_colaborador: false,
			data_nascimento: formData.data_nascimento ? formatarDataRequisicao(formData.data_nascimento) : null
		};

		data.dadosFornecedor = {
			nome_fantasia: formData.nome_fantasia,
			razao_social: formData.razao_social,
			responsavel: formData.responsavel,
			banco: formData.banco?.value || formData.banco,
			tipo_conta: formData.tipo_conta,
			agencia: formData.agencia,
			conta: formData.conta + formData.conta_digito,
			nome_titular: formData.nome_titular,
			documento_titular: formData.documento_titular
		};

		delete data.nome_fantasia;
		delete data.razao_social;
		delete data.responsavel;
		delete data.banco;
		delete data.tipo_conta;
		delete data.agencia;
		delete data.conta;
		delete data.conta_digito;
		delete data.nome_titular;
		delete data.documento_titular;

		Swal.fire({
			title: "Carregando...",
			allowOutsideClick: false,
			allowEscapeKey: false,
			showConfirmButton: false,
			didOpen: () => {
				Swal.showLoading();
			}
		});

		try {
			if (fornecedor != null) {
				await api.put(`/pessoas/${fornecedor.id}`, data);
			}
			else {
				await api.post(`/pessoas/fornecedores`, data);
			}

			onFornecedorAtualizado();
			onClose();
			Swal.fire('Sucesso', 'Fornecedor salvo com sucesso!', 'success');
		}
		catch (error) {
			Swal.close();
			Swal.fire('Erro', `${error.response?.data?.message || 'Erro ao salvar fornecedor'}`, 'error');
		}
	};

	return (
		<div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
			<div className="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
				<div className="modal-content" onClick={(e) => e.stopPropagation()}>
					<div className="modal-header">
						<h4 className="fw-bold mt-2">{tituloModal}</h4>
						<button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
					</div>
					<div className="modal-body">
						<form>
							<div className="row mt-4">
								<div className="col-12">
									<h6 className="fw-bold">Dados do Fornecedor</h6>
								</div>
							</div>
							<div className="row mt-3">
								<div className="col-lg-4 col-md-12">
									<label className="form-label fw-bold">Nome Fantasia</label>
									<input
										type="text"
										name="nome_fantasia"
										className="form-control"
										autoComplete="off"
										value={formData.nome_fantasia}
										onChange={handleChange}
									/>
								</div>
								<div className="col-lg-4 col-md-12 mt-lg-0 mt-3">
									<label className="form-label fw-bold">Razão Social</label>
									<input
										type="text"
										name="razao_social"
										className="form-control"
										autoComplete="off"
										value={formData.razao_social}
										onChange={handleChange}
									/>
								</div>
								<div className="col-lg-4 col-md-12 mt-lg-0 mt-3">
									<label className="form-label fw-bold">Responsável</label>
									<input
										type="text"
										name="responsavel"
										className="form-control"
										autoComplete="off"
										value={formData.responsavel}
										onChange={(e) => setFormData({ ...formData, responsavel: e.target.value.toUpperCase() })}
									/>
								</div>
							</div>

							<div className="row mt-4">
								<div className="col-12">
									<h6 className="fw-bold">Dados Gerais</h6>
								</div>
							</div>
							<div className="row mt-3">
								<div className="col-lg-4 col-md-12">
									<label className="form-label fw-bold">Nome</label>
									<input
										className="form-control"
										type="text"
										name="nome"
										autoComplete="off"
										value={formData.nome}
										onChange={(e) => setFormData({ ...formData, nome: e.target.value.toUpperCase() })}
										required
									/>
								</div>
								<div className="col-lg-4 col-md-12 mt-lg-0 mt-3">
									<label className="form-label fw-bold">CNPJ</label>
									<InputMask
										mask="__.___.___/____-__"
										replacement={{ _: /\d/ }}
										name="cnpj"
										className="form-control"
										autoComplete="off"
										value={formData.cnpj}
										onChange={handleChange}
									/>
								</div>
								<div className="col-lg-4 col-md-12 mt-lg-0 mt-3">
									<label className="form-label fw-bold">CPF</label>
									<InputMask
										mask="___.___.___-__"
										replacement={{ _: /\d/ }}
										name="cpf"
										className="form-control"
										autoComplete="off"
										value={formData.cpf}
										onChange={handleChange}
									/>
								</div>
							</div>
							<div className="row mt-3">
								<div className="col-lg-4 col-md-12">
									<label className="form-label fw-bold">E-mail</label>
									<input
										type="email"
										name="email"
										autoComplete="off"
										className="form-control"
										value={formData.email}
										onChange={handleChange}
									/>
								</div>
								<div className="col-lg-2 col-md-12 mt-lg-0 mt-3">
									<label className="form-label fw-bold">DDI</label>
									<input
										type="text"
										name="ddi"
										className="form-control"
										autoComplete="off"
										value={formData.ddi}
										onChange={handleChange}
									/>
								</div>
								<div className="col-lg-3 col-md-12 mt-lg-0 mt-3">
									<label className="form-label fw-bold">Celular</label>
									{formData.ddi === '+55' ? (
										<InputMask
											mask="(__) _____-____"
											replacement={{ _: /\d/ }}
											name="celular"
											autoComplete="off"
											className="form-control"
											value={formData.celular}
											onChange={handleChange}
											placeholder="(XX) XXXXX-XXXX"
										/>
									) : (
										<input
											type="text"
											name="celular"
											autoComplete="off"
											className="form-control"
											value={formData.celular}
											onChange={handleChange}
											placeholder="Digite o celular"
										/>
									)}
								</div>
								<div className="col-lg-3 col-md-12 mt-lg-0 mt-3">
									<label className="form-label fw-bold">Telefone</label>
									{formData.ddi === '+55' ? (
										<InputMask
											mask="(__) ____-____"
											replacement={{ _: /\d/ }}
											name="telefone"
											autoComplete="off"
											className="form-control"
											value={formData.telefone}
											onChange={handleChange}
											placeholder="(XX) XXXX-XXXX"
										/>
									) : (
										<input
											type="text"
											name="telefone"
											autoComplete="off"
											className="form-control"
											value={formData.telefone}
											onChange={handleChange}
											placeholder="Digite o telefone"
										/>
									)}
								</div>
							</div>

							<div className="row mt-4">
								<div className="col-12">
									<h6 className="fw-bold">Endereço</h6>
								</div>
							</div>
							<div className="row mt-3">
								<div className="col-lg-3 col-md-12">
									<label className="form-label fw-bold">CEP</label>
									<InputMask
										mask="_____-___"
										replacement={{ _: /\d/ }}
										name="cep"
										autoComplete="off"
										value={formData.cep}
										className="form-control"
										onBlur={buscarEndereco}
										onChange={handleChange}
										placeholder="XXXXX-XXX"
									/>
								</div>
								<div className="col-lg-3 col-12 mt-lg-0 mt-3">
									<label className="form-label fw-bold">Estado</label>
									<select
										name="estado"
										className="form-control"
										value={formData.estado}
										onChange={handleChange}
									>
										<option value="">Selecione...</option>
										{estados.map((option, index) => (
											<option key={index} value={option}>
												{option}
											</option>
										))}
									</select>
								</div>
								<div className="col-lg-3 col-12 mt-lg-0 mt-3">
									<label className="form-label fw-bold">Cidade</label>
									<input
										type="text"
										className="form-control"
										name="cidade"
										autoComplete="off"
										value={formData.cidade}
										onChange={handleChange}
									/>
								</div>
								<div className="col-lg-3 col-12 mt-lg-0 mt-3">
									<label className="form-label fw-bold">Bairro</label>
									<input
										type="text"
										name="bairro"
										className="form-control"
										autoComplete="off"
										value={formData.bairro}
										onChange={handleChange}
									/>
								</div>
							</div>
							<div className="row mt-3">
								<div className="col-lg-5 col-12">
									<label className="form-label fw-bold">Rua</label>
									<input
										type="text"
										name="rua"
										className="form-control"
										autoComplete="off"
										value={formData.rua}
										onChange={handleChange}
									/>
								</div>
								<div className="col-lg-2 col-12 mt-lg-0 mt-3">
									<label className="form-label fw-bold">Número</label>
									<input
										type="text"
										name="numero"
										className="form-control"
										autoComplete="off"
										value={formData.numero}
										onChange={handleChange}
									/>
								</div>
								<div className="col-lg-5 col-12 mt-lg-0 mt-3">
									<label className="form-label fw-bold">Complemento</label>
									<input
										type="text"
										name="complemento"
										className="form-control"
										autoComplete="off"
										value={formData.complemento}
										onChange={handleChange}
									/>
								</div>
							</div>

							<div className="row mt-4">
								<div className="col-12">
									<h6 className="fw-bold">Dados Bancários</h6>
								</div>
							</div>
							<div className="row mt-3">
								<div className="col-lg-6 col-12">
									<label className="form-label fw-bold">Banco</label>
									<Select
										options={bancosOptions}
										styles={customStyles}
										onInputChange={(value) => {
											handleAutoCompleteBancos(value);
										}}
										onFocus={handleFocusBancos}
										onChange={(value) => handleSelectChange('banco', value)}
										placeholder="Digite o nome do banco"
										isClearable
										menuPlacement="auto"
										menuPosition="fixed"
										noOptionsMessage={() => "Sem opções"}
										value={formData.banco}
									/>
								</div>
								<div className="col-lg-4 col-12 mt-lg-0 mt-3">
									<div>
										<label className="form-label fw-bold">Tipo de Conta</label>
									</div>
									<div className="form-check form-check-inline">
										<input
											className="form-check-input"
											type="radio"
											name="tipo_conta"
											value="corrente"
											checked={formData.tipo_conta === "corrente"}
											onChange={handleChange}
										/>
										<label className="form-check-label">Corrente</label>
									</div>
									<div className="form-check form-check-inline">
										<input
											className="form-check-input"
											type="radio"
											name="tipo_conta"
											value="poupanca"
											checked={formData.tipo_conta === "poupanca"}
											onChange={handleChange}
										/>
										<label className="form-check-label">Poupança</label>
									</div>
								</div>
							</div>
							<div className="row mt-3">
								<div className="col-lg-3 col-12">
									<label className="form-label fw-bold">Agência</label>
									<input
										type="text"
										className="form-control"
										name="agencia"
										autoComplete="off"
										value={formData.agencia}
										onChange={handleChange}
									/>
								</div>
								<div className="col-lg-3 col-12 mt-lg-0 mt-3">
									<label className="form-label fw-bold">Conta</label>
									<div className="d-flex">
										<input
											type="text"
											name="conta"
											className="form-control"
											autoComplete="off"
											value={formData.conta}
											onChange={handleChange}
										/>
										<input
											type="text"
											name="conta_digito"
											className="form-control w-auto ms-2"
											style={{ maxWidth: "80px" }}
											autoComplete="off"
											maxLength={1}
											value={formData.conta_digito}
											onChange={handleChange}
										/>
									</div>
								</div>
								<div className="col-lg-3 col-12 mt-lg-0 mt-3">
									<label className="form-label fw-bold">Nome do Titular</label>
									<input
										type="text"
										className="form-control"
										name="nome_titular"
										autoComplete="off"
										value={formData.nome_titular}
										onChange={(e) => setFormData({ ...formData, nome_titular: e.target.value.toUpperCase() })}
									/>
								</div>
								<div className="col-lg-3 col-12 mt-lg-0 mt-3">
									<label className="form-label fw-bold">Documento do Titular</label>
									<input
										type="text"
										name="documento_titular"
										className="form-control"
										autoComplete="off"
										value={formData.documento_titular}
										onChange={handleChange}
									/>
								</div>
							</div>

							<div className="row mt-4">
								<div className="col-12">
									<h6 className="fw-bold">Observações</h6>
								</div>
							</div>
							<div className="row mt-3">
								<div className="col-12">
									<textarea
										name="observacao"
										className="form-control"
										autoComplete="off"
										value={formData.observacao}
										onChange={handleChange}
										rows="3"
									></textarea>
								</div>
							</div>
						</form>
					</div>

					<div className="modal-footer mt-4">
						<div className="row">
							<div className="col-12 text-end">
								<button className="btn btn-outline-danger" type="button" onClick={onClose}>
									<FaTimes /> Fechar
								</button>
								<button className="btn btn-custom-primary ms-3" type="submit" onClick={handleSubmit}>
									<FaRegSave /> Salvar
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div >
	);
};

export default FornecedorModal;
